import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/src/components/ui/select";
import { useEmit } from "@/src/lib/actions";
import { SortByCustomersOptions, SortByOperatorsOptions, SortByOptions } from "./state";
import { useState } from "react";
import { PayerType } from "./model";

const OrderBySelect = ({ payerType }: { payerType: PayerType }) => {
  const [value, setValue] = useState(SortByOptions.NAME);

  const emitSortBy = useEmit<SortByOptions>("customers:sortBy");

  const onValueChange = (value: SortByOptions) => {
    setValue(value);
    emitSortBy(value as SortByOptions);
  };

  return (
    <div className="w-60">
      <Select onValueChange={onValueChange} value={value}>
        <SelectTrigger>
          <SelectValue placeholder="Sort by" />
        </SelectTrigger>
        <SelectContent>
          <>
            <SelectItem value={SortByOptions.NAME}>Sort by: Customer name A-Z</SelectItem>
            <SelectItem value={SortByOptions.SURNAME}>Sort by: Customer surname A-Z</SelectItem>
            <SelectItem value={SortByOptions.EMAIL}>Sort by: Customer email A-Z</SelectItem>
          </>
        </SelectContent>
      </Select>
    </div>
  );
};

export default OrderBySelect;
